import { render } from "./Protocols.vue?vue&type=template&id=daa5ecb2&scoped=true"
import script from "./Protocols.vue?vue&type=script&lang=js"
export * from "./Protocols.vue?vue&type=script&lang=js"

import "./Protocols.vue?vue&type=style&index=0&id=daa5ecb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa5ecb2"]])

export default __exports__